<style scoped>
.content-wrapper .content {
    padding-top: 95px;
}
.el-select {
    display: block;
}
ul.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
}
ul.bucket-list li.buckets {
    display: inline-block;
    padding: 5px 20px;
    background: #7c6eb8;
    border-radius: 40px;
    margin-right: 10px;
}
ul.bucket-list li.buckets span {
    color: #ffffff;
}
ul.bucket-list li.no-result {
    display: block;
}
</style>
<template>
    <!-- <transition name="el-zoom-in-top"> -->
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Create/Edit Bucket</h3>
                </div>
                <div class="box-body">
                    <form method="post" v-on:submit.prevent="onSubmit" class="form">
                        <h5>Bucket name</h5>
                        <el-input
                            class=""
                            v-validate="'required'"
                            data-vv-delay="200"
                            :class="{
                                input: true,
                                'is-danger': errors.has('bname'),
                            }"
                            name="bname"
                            type="text"
                            placeholder="Bucket Name"
                            v-model="formData.bname"
                        ></el-input>
                        <span v-show="errors.has('bname')" class="help is-danger">{{ errors.first('bname') }}</span>
                        <hr />

                        <h5>Select Countries</h5>
                        <el-select
                            v-model="formData.country"
                            :change="disable(formData.country)"
                            placeholder="Select country"
                            multiple
                            filterable
                        >
                            <el-option
                                v-for="option in countries"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id"
                                :disabled="displayexistingCountries.indexOf(option.id) > -1"
                            ></el-option>
                            <!-- <el-option v-for="option in countries" :key="option.id" :label="option.name" :value="option.id"></el-option> -->
                        </el-select>
                        <hr />
                        <h5>Associate Products</h5>
                        <el-select v-model="formData.prod" placeholder="Select products">
                            <el-option key="" label="Select a product" value=""></el-option>
                            <el-option v-for="prod in products" :key="prod.id" :label="prod.name" :value="prod.id">
                            </el-option>
                        </el-select>
                        <hr />
                        <hr />

                        <div class="row">
                            <div class="col-md-4">
                                <el-checkbox
                                    v-model="formData.isMobile"
                                    @change="loadExistingCountries"
                                    :disabled="!formData.isMobileEnable"
                                    >Mobile enabled?</el-checkbox
                                >
                            </div>
                            <div class="col-md-4">
                                <el-checkbox
                                    v-model="formData.isWeb"
                                    @change="loadExistingCountries"
                                    :disabled="!formData.isWebEnable"
                                    >Web enabled?</el-checkbox
                                >
                            </div>
                            <div class="col-md-4">
                                <el-checkbox
                                    v-model="formData.isTablet"
                                    @change="loadExistingCountries"
                                    :disabled="!formData.isTabletEnable"
                                    >Tablet enabled?</el-checkbox
                                >
                            </div>
                        </div>
                        <hr />

                        <div class="clearfix">
                            <el-button @click="onSubmit()" type="success">
                                <i
                                    class="el-icon-left"
                                    :class="{
                                        'el-icon-edit': bucketId !== undefined,
                                        'el-icon-plus': bucketId === undefined,
                                    }"
                                ></i>
                                {{ bucketId === undefined ? 'Create Bucket' : 'Edit Bucket' }}
                            </el-button>
                            <router-link
                                :to="`${'/admin/publisher/' + uuid + '/domain/edit/' + domId + '/'}`"
                                class="el-button el-button--danger"
                            >
                                Cancel
                            </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
    data() {
        return {
            formData: {
                bname: undefined,
                country: [],
                isMobile: true,
                isWeb: true,
                isTablet: true,
                prod: undefined,
                isMobileEnable: true,
                isWebEnable: true,
                isTabletEnable: true,
            },
            bucketId: undefined,
            prod: undefined,
            countries: [],
            domId: undefined,
            validated: undefined,
            uuid: undefined,
            displayexistingCountries: [],
            existingCountries: [],
            existingCountriesMobile: [],
            existingCountriesDesktop: [],
            existingCountriesTablet: [],
            existingCountriesMobileDup: [],
            existingCountriesDesktopDup: [],
            existingCountriesTabletDup: [],
            products: [],
            assocProd: [],
        };
    },
    created: function () {
        this.uuid = this.$route.params.uuid;
        this.domId = this.$route.params.domId;
        this.copyFormData = JSON.parse(JSON.stringify(this.formData));

        axios
            .all([
                axios.get(BASE_URL + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/'),
                axios.get(BASE_URL + 'v1/countries/'),
                axios.get(BASE_URL + 'v1/products/'),
            ])
            .then(
                axios.spread((buckets, countriesres, products) => {
                    this.buckets = buckets.data;
                    for (let i = 0; i < this.buckets.length; i++) {
                        for (let j = 0; j < this.buckets[i].countries.length; j++) {
                            if (this.buckets[i].countries[j].name != 'All') {
                                if (
                                    this.buckets[i].mobile_enabled == true &&
                                    this.buckets[i].web_enabled == true &&
                                    this.buckets[i].tablet_enabled == true
                                ) {
                                    this.existingCountries.push(this.buckets[i].countries[j].id);
                                }

                                if (
                                    this.existingCountriesMobile.indexOf(this.buckets[i].countries[j].id) == -1 &&
                                    this.buckets[i].mobile_enabled
                                ) {
                                    console.log('only mobile me he');
                                    this.existingCountriesMobile.push(this.buckets[i].countries[j].id);
                                }
                                if (
                                    this.existingCountriesDesktop.indexOf(this.buckets[i].countries[j].id) == -1 &&
                                    this.buckets[i].web_enabled
                                ) {
                                    this.existingCountriesDesktop.push(this.buckets[i].countries[j].id);
                                }
                                if (
                                    this.existingCountriesTablet.indexOf(this.buckets[i].countries[j].id) == -1 &&
                                    this.buckets[i].tablet_enabled
                                ) {
                                    this.existingCountriesTablet.push(this.buckets[i].countries[j].id);
                                }
                                if (
                                    this.existingCountriesMobile.includes(this.buckets[i].countries[j].id) &&
                                    this.existingCountriesDesktop.includes(this.buckets[i].countries[j].id) &&
                                    this.existingCountriesTablet.includes(this.buckets[i].countries[j].id)
                                ) {
                                    console.log('both me exist he');
                                    this.existingCountries.push(this.buckets[i].countries[j].id);
                                }
                            }
                        }
                    }
                    this.displayexistingCountries = this.existingCountries;
                    console.log(this.displayexistingCountries);
                    this.countries = countriesres.data;
                    this.products = products.data;
                })
            )
            .catch((error) => {
                if (error.response && error.response.status === 403) {
                    this.$notify({
                        title: 'Warning',
                        message: 'Something went wrong.',
                        type: 'warning',
                    });
                } else {
                    console.log(error);
                }
            });
    },
    methods: {
        loadExistingCountries() {
            if (this.formData.isMobile && !this.formData.isWeb && !this.formData.isTablet) {
                this.displayexistingCountries = this.existingCountriesMobile;
            } else if (!this.formData.isTablet && !this.formData.isMobile && this.formData.isWeb) {
                this.displayexistingCountries = this.existingCountriesDesktop;
            } else if (this.formData.isTablet && !this.formData.isWeb && !this.formData.isMobile) {
                this.displayexistingCountries = this.existingCountriesTablet;
            } else {
                console.log('Both');
                this.displayexistingCountries = this.existingCountries;
            }
            // console.log(this.displayexistingCountries,'hit!!!!');
        },
        disable(name) {
            if (
                this.existingCountriesMobileDup.length == this.formData.country.length &&
                this.existingCountriesDesktopDup.length == this.formData.country.length &&
                this.existingCountriesTabletDup.length == this.formData.country.length
            )
                return;
            this.formData.isMobile = true;
            this.formData.isWeb = true;
            this.formData.isTablet = true;
            this.formData.isMobileEnable = true;
            this.formData.isWebEnable = true;
            this.formData.isTabletEnable = true;

            var tempIsMobile = true;
            var tempIsWeb = true;
            var tempIsTablet = true;
            var tempIsMobileEnable = true;
            var tempIsWebenable = true;
            var tempIsTabletEnable = true;

            console.trace('disable');
            console.log('change country array of length %%%%%%%%%%%', name.length);
            for (var i = 0; i < name.length; i++) {
                console.log('indivisual element$$$$$$$$$$$$', name[i]);
                var idCompareTo = name[i];

                if (this.existingCountriesMobile.includes(idCompareTo)) {
                    tempIsMobile = false;
                    tempIsMobileEnable = false;
                }

                if (this.existingCountriesDesktop.includes(idCompareTo)) {
                    tempIsWeb = false;
                    tempIsWebenable = false;
                }

                if (this.existingCountriesTablet.includes(idCompareTo)) {
                    tempIsTablet = false;
                    tempIsTabletEnable = false;
                }
            }
            console.log('tempmobile^^^^^^^^^^^^^6=', tempIsMobile);
            console.log('tempweb^^^^^^^^^^^^^6=', tempIsWeb);
            if (!tempIsMobile) {
                this.formData.isMobileEnable = false;
                this.formData.isMobile = false;
            }
            if (!tempIsWeb) {
                this.formData.isWebEnable = false;
                this.formData.isWeb = false;
            }
            if (!tempIsTablet) {
                this.formData.isTabletEnable = false;
                this.formData.isTablet = false;
            }
            console.log('temptablet^^^^^^^^^^^^^6=', tempIsTablet);
            // console.log('hit!!!!',this.formData.country)

            this.existingCountriesMobileDup = JSON.parse(JSON.stringify(this.formData.country));
            this.existingCountriesDesktopDup = JSON.parse(JSON.stringify(this.formData.country));
            this.existingCountriesTabletDup = JSON.parse(JSON.stringify(this.formData.country));
        },
        onSubmit() {
            let prod = this.formData.prod;
            console.log('prod', prod);

            if (prod == undefined) {
                console.log('not slect product');
                this.$notify({
                    title: 'Warning',
                    message: 'Please select product',
                    type: 'warning',
                });
                return;
            }

            if (this.formData.isMobile == false && this.formData.isWeb == false && this.formData.isTablet == false) {
                console.log('not slect anything mobile nd web');
                this.$notify({
                    title: 'Warning',
                    message: 'Please check atleast one device!',
                    type: 'warning',
                });
                return;
            }

            let payload = {
                    pub_id: this.uuid,
                    domId: this.domId,
                    name: this.formData.bname,
                    domain: this.domId,
                    countries: this.formData.country,
                    mobile_enabled: this.formData.isMobile,
                    web_enabled: this.formData.isWeb,
                    tablet_enabled: this.formData.isTablet,
                },
                apiLink = undefined;
            console.log('payload info pubid', payload.pub_id);
            console.log('payload info domID', payload.domId);
            console.log('payload info name', payload.name);
            console.log('payload info domain', payload.domain);
            console.log('payload info country', payload.countries);

            console.log('payload info mobile-enable', payload.isWeb);
            console.log('payload info web-enable', payload.isMobile);
            console.log('payload info tablet-enable', payload.isMobile);

            apiLink = BASE_URL + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/';

            for (let i = 0; i < this.formData.country.length; i++)
                if (this.existingCountries.indexOf(this.formData.country[i]) == -1)
                    this.existingCountries.push(this.formData.country[i]);

            axios
                .post(apiLink, payload)
                .then((response) => {
                    this.formData = JSON.parse(JSON.stringify(this.copyFormData));
                    var newBucket = response.data.id;
                    axios
                        .all([
                            axios.get(BASE_URL + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/'),
                        ])
                        .then(
                            axios.spread((buckets) => {
                                this.buckets = buckets.data;
                                for (let i = 0; i < this.buckets.length; i++)
                                    for (let j = 0; j < this.buckets[i].countries.length; j++)
                                        if (this.existingCountries.indexOf(this.buckets[i].countries[j].id) == -1)
                                            this.existingCountries.push(this.buckets[i].countries[j].id);

                                axios
                                    .post(
                                        BASE_URL +
                                            'v1/publishers/' +
                                            this.uuid +
                                            '/domains/' +
                                            this.domId +
                                            '/buckets/' +
                                            newBucket +
                                            '/products/',
                                        {
                                            bucket_id: newBucket,
                                            pub_id: this.uuid,
                                            domId: this.domId,
                                            bucket: newBucket,
                                            product: prod,
                                        }
                                    )
                                    .then((response) => {
                                        this.$notify({
                                            title: 'Success',
                                            message: 'Successfully created a bucket & associated a product',
                                            type: 'success',
                                        });

                                        setTimeout(() => {
                                            this.$router.push(
                                                '/admin/publisher/' +
                                                    this.$route.params.uuid +
                                                    '/domain/edit/' +
                                                    this.$route.params.domId
                                            );
                                        }, 1000);
                                    })
                                    .catch((error) => {
                                        this.$notify({
                                            title: 'Error',
                                            message: 'Cannot use more than one Product witha Bucket',
                                            type: 'error',
                                        });
                                    });
                            })
                        );
                })
                .catch((error) => {
                    this.$notify({
                        title: 'Warning',
                        message: 'Something went wrong.',
                        type: 'warning',
                    });
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// DomainBucket.vue?a64c1504